// extracted by mini-css-extract-plugin
export default {"botaoPrincipal":"BotaoPrincipal_botaoPrincipal__nII6e","lg":"BotaoPrincipal_lg__I3rzo"};